import { render, staticRenderFns } from "./CarouselCards.vue?vue&type=template&id=394e73d1&%3Aclass=coachEffectClass&%3Akey=%24store.state.calculatorRerender&"
import script from "./CarouselCards.vue?vue&type=script&lang=js&"
export * from "./CarouselCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
installComponents(component, {VCarousel,VCarouselItem})
